import { useEffect, useState } from 'react'
import { FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa'
import { IoMdMail } from 'react-icons/io'
import { SelectLanguage } from '../component/SelectLanguage'
import './Navbar.scss'

const Navbar = () => {
	const [scrolled, setScrolled] = useState<boolean | null>(null)

	const handleScroll = () => {
		const isScrolled = window.scrollY > 1
		setScrolled(isScrolled)
	}

	useEffect(() => {
		window.addEventListener('scroll', handleScroll)
		return () => window.removeEventListener('scroll', handleScroll)
	}, [])

	return (
		<nav
			className={`navbar ${
				scrolled !== null ? (scrolled ? 'scrolled' : 'unscrolled') : ''
			}`}
		>

			<div className={`logo ${scrolled && ''}`}>
				<img
					className={`icon ${!scrolled && 'white-icon'}`}
					src='/dan-3-trading-logo2.png'
					alt='Agro-icon'
				/>
				<span className='font-medium w-[200px] sm:w-auto whitespace-pre-line'>DAN 3 TRADING GmbH</span>
			</div>

			<div className='flex'>
				<SelectLanguage />
				<div className='contacts mr-[20px]'>
					<div className='phone'>
						<FaPhoneAlt size={25} />
						<span>+43 664 1531 501 Tanja Kaiser</span>
					</div>
					<div className='phone'>
						<FaPhoneAlt size={25} />
						<span>+43 664 1323 558 Jan Kaiser</span>
					</div>
				</div>

				<div className='contacts'>
					<div className='phone'>
							<IoMdMail size={20} />
							<span>dan3trading@dan3trading.com</span>
						</div>
						<div className='phone'>
							<FaMapMarkerAlt size={20} />
							<span style={{ whiteSpace: 'pre-wrap' }}>
								{`St. Veiter Straße 101,\n 9020 KLAGENFURT, Österreich`}
							</span>
						</div>
				</div>
			</div>

			{/* <div className='contacts'>
        <div className='phone'>
          <FaPhoneAlt size={25} />
          <Icons icon='Ukraine' className='flag' />
          <span>+380976588486</span>
        </div>
        <div className='phone'>
          <FaPhoneAlt size={25} />
          <Icons icon='Austria' className='flag' />
          <span>+4366475020911</span>
        </div>
        <div className='phone'>
          <IoMdMail size={25} />
          <span>Glovatsky.anton@gmail.com</span>
        </div>
      </div> */}
		</nav>
	)
}

export default Navbar
